import React, { Component } from "react"
import { Formik, Field } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18n from "../../i18n";
import * as rk from "../../localization/resourceKeys";
import * as T from "../../redux/constants";
import customInputComponent from '../../forms/customInputBronson';
import { ccpaFormValidations } from '../../utils/validations';

class UpdateEmail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditEmail: false,
    }
  }

  componentDidUpdate() {
    ccpaFormValidations();
  }

  validate() {
    let returnValue = Yup.object().shape({
      emailAddress: Yup.string()
        .required(i18n.t(rk.CCPA_FORM_ERROR.EMAIL_ADDRESS_ERROR))
        .email(i18n.t(rk.CCPA_FORM_ERROR.EMAIL_ADDRESS_ERROR))
        .max(50, i18n.t(rk.CCPA_FORM_ERROR.EMAIL_ADDRESS_ERROR)),
      reEnterEmailAddress: Yup.string()
        .required(i18n.t(rk.CCPA_FORM_ERROR.REENTER_ADDRESS_ERROR))
        .email(i18n.t(rk.CCPA_FORM_ERROR.REENTER_ADDRESS_ERROR))
        .max(50, i18n.t(rk.CCPA_FORM_ERROR.REENTER_ADDRESS_ERROR))
        .oneOf([Yup.ref('emailAddress')], i18n.t(rk.EMAIL_DONT_MATCH)),
    })
    return returnValue;
  }

  render() {
    return (
      <div className={`right-to-correct-row ${this.state.isEditEmail && "update-email"}`}>
        {this.state.isEditEmail ? (
          <div>
            <div className="u-m">
              {this.props.correctedEmailState.isCorrectedEmail ? (
                <div className="row-container">
                  <div className="pending-changes-data">
                    <div className="submission-pending-left-container">
                      <div>
                        <span className='right-to-correct-input-label'>{i18n.t(rk.DATA_CORRECTION.EMAIL_LABEL)}: </span>{this.props.correctedEmailState.emailAddress}
                      </div>
                    </div>
                  </div>
                  <div className="right-row_content_right">
                    <div className="submission-pending-right-container">
                      <div className="pending-text-container u-float-left u-mr">
                        <i className="c-icon-list__icon  c-icon  c-icon--[semantic-checkmark]  u-text-success" aria-hidden="true" role="img"></i>
                        <span className="submission-pending-text">{i18n.t(rk.DATA_CORRECTION.PENDING_CHANGES)}</span>
                      </div>
                      <button
                        className="cancel-btn c-btn u-m-none u-float-right"
                        onClick={() => {
                          this.props.clearCorrectedEmail();
                          this.setState({ isEditEmail: false });
                        }}
                        id="cancel-email-changes-btn"
                        data-testid="cancel-email-changes-btn"
                      >
                        <span className="c-btn__text">
                          {i18n.t(rk.BUTTON.CANCEL)}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Formik
                  initialValues={{
                    emailAddress: "",
                    reEnterEmailAddress: "",
                  }}
                  onSubmit={async (values, { setSubmitting }) => {
                    await this.props.saveCorrectedEmail(values);
                    setSubmitting(false);
                  }}
                  validationSchema={this.validate()}
                >
                  {props => {
                    const { handleSubmit, values } = props;
                    return (
                      <div className="row-container">
                        <div className="o-layout u-m-none">
                          <div className="o-layout__item u-1/1 u-m-none u-p-none">
                            <Field
                              id="emailAddress"
                              name="emailAddress"
                              data-testid="emailAddress"
                              placeHolder={i18n.t(rk.COMMON.EMAIL_ADDRESS)}
                              altPlaceholder={(i18n.t(rk.COMMON.EMAIL_ADDRESS)).toUpperCase()}
                              type="email"
                              component={customInputComponent}
                              error={props.errors.emailAddress}
                              helpContent={props.errors.emailAddress && props.touched.emailAddress ? props.errors.emailAddress : ""}
                            />
                          </div>
                          <div className="o-layout__item u-1/1 u-m-none u-p-none">
                            <Field
                              id="reEnterEmailAddress"
                              name="reEnterEmailAddress"
                              data-testid="reEnterEmailAddress"
                              placeHolder={i18n.t(rk.COMMON.RENTER_EMAIL_ADDRESS)}
                              altPlaceholder={(i18n.t(rk.COMMON.RENTER_EMAIL_ADDRESS)).toUpperCase()}
                              type="email"
                              component={customInputComponent}
                              error={props.errors.reEnterEmailAddress}
                              onPaste={this.onPaste}
                              helpContent={props.errors.reEnterEmailAddress && props.touched.reEnterEmailAddress ? props.errors.reEnterEmailAddress : ""}
                            />
                          </div>
                        </div>
                        <div className="right-row_content_right">
                          <div className="btn-wrapper">
                            <button
                              className="cancel-btn c-btn u-m-none u-mr"
                              onClick={() => { this.setState({ isEditEmail: false }) }}
                              id="cancel-update-email-btn"
                              data-testid="cancel-update-email-btn"
                            >
                              <span className="c-btn__text">
                                {i18n.t(rk.BUTTON.CANCEL)}
                              </span>
                            </button>
                            <div className="save-btn-wrapper u-float-right">
                              <button
                                className="u-m-none c-btn"
                                data-testid="save-email-btn"
                                id="save-email-btn"
                                onClick={handleSubmit}
                                disabled={!(values.emailAddress && values.reEnterEmailAddress)}
                              >
                                <span className="c-btn__text">
                                  {i18n.t(rk.BUTTON.SAVE)}
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  }}
                </Formik>
              )}
            </div>
          </div>
        ) : (
          <div className="row-container">
            <div className="u-m right-to-correct-input-label">{i18n.t(rk.DATA_CORRECTION.EMAIL_LABEL)}</div>
            <div className="right-row_content_right">
              <div className="update-btn-wrapper">
                <button
                  className="update-btn c-btn u-m-none u-mr"
                  onClick={() => { this.setState({ isEditEmail: true }) }}
                  id={`update-email-btn`}
                  data-testid={`update-email-btn`}
                >
                  <span className="c-btn__text">
                    {i18n.t(rk.BUTTON.UPDATE)}
                  </span>
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

UpdateEmail.propTypes = {
  correctedEmailState: PropTypes.object,
  saveCorrectedEmail: PropTypes.func,
  clearCorrectedEmail: PropTypes.func,
};

const mapStateToProps = state => ({
  correctedEmailState: state.rightToCorrectReducer
});

const mapDispatchToProps = dispatch => ({
  saveCorrectedEmail: values => dispatch({ type: T.RIGHT_TO_CORRECT.UPDATE_EMAIL, payload: values }),
  clearCorrectedEmail: () => dispatch({ type: T.RIGHT_TO_CORRECT.CLEAR_UPDATED_EMAIL }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(UpdateEmail));
